import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: 50%;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  &:active {\n    background-color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  border-radius: 50%;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  &:active {\n    background-color: ', ';\n  }\n']);

import styled from 'styled-components';
import { drawerBackIconSize } from '../../utils/drawer-style-variables';
import { getProvided } from '../../theme/util';

var DrawerBackIconOuter = styled.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return getProvided(theme).item.default.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getProvided(theme).text;
}, drawerBackIconSize, drawerBackIconSize, function (_ref3) {
  var theme = _ref3.theme;
  return getProvided(theme).item.active.background;
});

DrawerBackIconOuter.displayName = 'DrawerBackIconOuter';
export default DrawerBackIconOuter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/DrawerBackIconOuter.js
// module id = 718
// module chunks = 0